import AddFromHistoryDialog from "./AddFromHistoryDialog";
import TraceHistoryImportContent from "./TraceHistoryImportContent";

import type { SmartTableTraceImportPayload } from "@/queries/smart-tables/useSmartTableTraceImports";

interface AddFromTracesButtonProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onImport: (payload: SmartTableTraceImportPayload) => Promise<boolean>;
  isImporting: boolean;
  importProgress: number | null;
  selectionLimit?: 1;
  actionLabel?: string;
  title?: string;
  tableId?: string;
  sheetId?: string;
  targetColumnId?: string | null;
}

const AddFromTracesButton = ({
  open,
  onOpenChange,
  onImport,
  isImporting,
  importProgress,
  selectionLimit,
  actionLabel,
  title = "Add from Trace History",
  tableId,
  sheetId,
  targetColumnId,
}: AddFromTracesButtonProps) => (
  <AddFromHistoryDialog<SmartTableTraceImportPayload>
    open={open}
    onOpenChange={onOpenChange}
    title={title}
    isImporting={isImporting}
    importProgress={importProgress}
    onImport={onImport}
    selectionLimit={selectionLimit}
    actionLabel={actionLabel}
    tableId={tableId}
    sheetId={sheetId}
    targetColumnId={targetColumnId}
    Content={TraceHistoryImportContent}
  />
);

export default AddFromTracesButton;
